import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// PUBLIC_URL 환경변수를 가져옵니다 (로컬: '', 운영: '/new')
const publicUrl = process.env.PUBLIC_URL || '';

// 개발환경인지 확인
const isDevelopment = process.env.NODE_ENV === 'development';

i18n
  .use(Backend) // 백엔드에서 번역 파일 로드
  .use(LanguageDetector) // 브라우저 언어 감지
  .use(initReactI18next) // React i18next 초기화
  .init({
    fallbackLng: 'ko', // 기본 언어
    debug: isDevelopment, // 개발 환경에서만 디버그
    
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    
    interpolation: {
      escapeValue: false, // React는 이미 XSS를 방지함
    },
    
    backend: {
      // publicUrl을 사용하여 올바른 경로 생성
      // 로컬: /locales/ko/common.json
      // 운영: /new/locales/ko/common.json
      loadPath: `${publicUrl}/locales/{{lng}}/{{ns}}.json`,
      
      // 캐시 무효화를 위한 쿼리 파라미터 추가 (선택사항)
      queryStringParams: { v: '1.0' },
      
      // CORS 관련 설정
      crossDomain: true,
      withCredentials: false,
    },
    
    ns: ['common', 'home', 'introduce', 'business', 'cs'], // 네임스페이스
    defaultNS: 'common',
    
    // 로드 옵션
    load: 'languageOnly', // 'ko-KR' 대신 'ko'만 사용
    
    react: {
      useSuspense: false // Suspense 비활성화
    },
    
    // 리소스 로드 실패 시 처리
    saveMissing: isDevelopment, // 개발 환경에서 누락된 키 저장
    missingKeyHandler: isDevelopment ? 
      (lng: string[], ns: string, key: string) => {
        console.warn(`Missing translation key: ${key} in ${ns} for ${lng}`);
      } : false,
  });

// i18n 초기화 확인 로그 (개발 환경에서만)
if (isDevelopment) {
  i18n.on('initialized', () => {
    console.log('i18n initialized with publicUrl:', publicUrl);
  });
  
  i18n.on('loaded', (loaded) => {
    console.log('i18n resources loaded:', loaded);
  });
  
  i18n.on('failedLoading', (lng, ns, msg) => {
    console.error(`Failed to load ${ns} for ${lng}:`, msg);
  });
}

export default i18n;
